import { Component, ViewChild, Input, Output, ElementRef, EventEmitter, NgZone } from '@angular/core';
import { AbstractControl, FormControl, FormGroup, FormArray, FormsModule, ValidatorFn, Validators } from '@angular/forms';
import { TagsRoutingModule } from './tags.routing.module';

declare let $: any;
const errorMessage: any = {
  required: 'Ce champ est requis',
  maxlength: 'Ce champ est trop long ',
  pattern: 'Ce champ doit correspondre au pattern '
};

@Component({
  selector: 'tags',
  template: `
  <div class="md-form form-sm" *ngIf="visible && form.controls[name]" [ngClass]="{'has-error':error}" [formGroup]="form">
    <i *ngIf="glyph" class="{{glyph}} prefix" [ngClass]="{'active':control.value}"></i>
    <div #tags id="{{name}}" (focus)="onFocus()" [ngStyle]="{'font-style': (readonly ? 'italic' :'') }" class="form-control chips tagscomp"
      [attr.length]="length" [ngClass]="{'invalid': error}"></div>
    <label for="{{name}}" [ngClass]="{'active':control.value}">
      <em *ngIf="readonly">{{caption}}</em>
      <b *ngIf="!readonly">{{caption}}</b>
      <span *ngIf="required && !control.value" style="color: red;">
        <b>*</b>
      </span>
    </label>
    <span *ngIf="error" class="help-block text-danger" [ngStyle]="{'padding-left': (glyph ? '48px' :'')}" style="font-size: 15px">
      <b>{{ error }}</b>
    </span>
  </div>`,
  styles: [`
  .tagscomp {
      margin-bottom: 0;
      margin-left: 2.2rem;
      width: 92%;
      width: calc(100% - 3rem);
  }

  .tagscomp.ng-invalid {
      border-bottom: 1px solid #F44336;
      box-shadow: 0 1px 0 0 #F44336;
  }

  .chips {
      padding-bottom: 0;
  }`]
})

export class TagsComponent {

  @Input() public name: string = '';
  @Input() public length: string = '0';
  @Input() public caption: string = '';
  @Input() public readonly: boolean = false;
  @Input() public control: AbstractControl;
  @Input() public enabled: boolean = false;
  @Input() public value: string[] = [];
  @Input() public glyph: string = '';
  @Output() public valueChange = new EventEmitter<string>();
  @Input() public form: FormGroup;
  @Input() public error: any;
  @Input() public required: boolean = false;
  @Input() public displayCharacterCounter: boolean = true;
  public elementRef: ElementRef;
  @Input() public visible: boolean = true;
  @Input() public validators: ValidatorFn[] = new Array<ValidatorFn>();
  @Input() public pattern: any = null;
  @Input() public patternHint: string = '';
  @Input() public upperCase: boolean = true;
  @Input() public init: boolean = false;
  public zone: any;

  @ViewChild('tags') tags: ElementRef;

  constructor(zone: NgZone) {
    this.zone = zone;
  }

  ngOnInit(): void {
    if (!this.control) {
      if (this.form.controls[this.name] == null) {
        this.control = new FormControl();
        //let formgroup: FormGroup = <FormGroup>(this.control.controls[control.controls.length - 1]);
        this.form.addControl(this.name, this.control);
      }
      this.control = this.form.controls[this.name];
    }
    this.updateValidators();
    this.control.valueChanges
      .subscribe((value) => {
        this.returnError();
      });
    this.init = true;
  }

  ngOnChanges(change: any) {
    if (this.init) {
      if (change.required || change.pattern || change.length) {
        this.updateValidators();
      }
    }
  }

  ngAfterViewInit() {
    const tags: Object[] = [];
    if (this.value) {
      this.value = this.value.toString().split(',');
      this.value.forEach((element: any) => {
        tags.push({ tag: element });
      });
      this.control.patchValue(JSON.stringify(this.value));
    } else {
      this.value = [];
    }
    $(this.tags.nativeElement).material_chip({
      data: tags
    });
    $(this.tags.nativeElement).on('chip.add', () => {
      this.zone.run(() => {
        this.updateTags();
      });
    });
    $(this.tags.nativeElement).on('chip.delete', () => {
      this.zone.run(() => {
        this.updateTags();
      });
    });
  }

  public updateTags() {
    this.value = [];
    const tags: Object[] = $(this.tags.nativeElement).material_chip('data');
    tags.forEach((element: any) => {
      this.value.push(element.tag);
    });
    if (this.value.length > 0) {
      this.control.patchValue(JSON.stringify(this.value));
    } else {
      this.control.patchValue(null);
    }
  }

  updateValidators() {
    this.validators = new Array<ValidatorFn>();
    if (this.required) {
      this.validators.push(Validators.required);
    }
    if (this.length != '0') {
      this.validators.push(Validators.maxLength(parseInt(this.length)));
    }
    if (this.pattern) {
      this.validators.push(Validators.pattern(this.pattern));
    }
    this.control.setValidators(this.validators);
    this.control.updateValueAndValidity();
  }

  addErrorMessage(key: string, msg: string) {
    errorMessage[key] = msg;
  }

  setReadonly(readonly: boolean) {
    this.readonly = readonly;
  }

  returnError() {
    this.error = '';
    if (this.control && !this.control.valid && this.control.errors) {
      for (const key in this.control.errors) {
        if (key in errorMessage) {
          if (key == 'pattern') {
            this.error += errorMessage[key] + ' ' + this.patternHint + ' ';
          } else if (key == 'maxlength') {
            this.error += errorMessage[key] + ' ' + this.length + ' ';
          } else {
            this.error += errorMessage[key] + ' ';
          }
        }
      }
    }
  }

}
